module.exports = __webpack_public_path__ + "img/background-microclaudia.d521dba.jpg";